// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skitterbook-live-print-button-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-content: center;
    flex-wrap: wrap;
    gap: 1rem;
}

.skitterbook-live-print-button {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.skitterbook-live-print-button {
    color: inherit;
}

    .skitterbook-live-print-button > .glyph-button-content {
        color: inherit;
    }

        .skitterbook-live-print-button > .glyph-button-content > svg {
            stroke: inherit;
            fill: inherit;
        }

.skitterbook-live-print-button--ready {
    color: var(--color-success);
    stroke: var(--color-success);
    fill: var(--color-success);
}

.skitterbook-live-print-button--loading {
    color: var(--color-disabled-fore);
    stroke: var(--color-disabled-fore);
    fill: var(--color-disabled-fore);
}

svg.error-information {
    position: absolute;
    left: 16px;
    top: 16px;
    stroke: var(--color-error);
    fill: var(--color-error);
    transition: opacity 0.5s ease;
    opacity: 0;
    display: none;
}

.skitterbook-live-print-button--error {
    color: var(--color-error);
    stroke: var(--color-error);
    fill: var(--color-error);
}

    .skitterbook-live-print-button--error ~ svg.error-information {
        display: block;
        opacity: 1;
    }

.skitterbook-live-print-button--building > .glyph-button-content {
    color: var(--color-secondary);
    stroke: var(--color-secondary);
    fill: var(--color-secondary);
    animation: sbpb-pulse 1.4s ease-in-out infinite;
}

@keyframes sbpb-pulse {
    0% {
        transform: scale(0.9);
        opacity: 0.6;
    }

    50% {
        transform: scale(1.1);
        opacity: 1;
    }

    100% {
        transform: scale(0.9);
        opacity: 0.6;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Skitterbook/css/SkitterBookLivePrintButton.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;IAEI;QACI,cAAc;IAClB;;QAEI;YACI,eAAe;YACf,aAAa;QACjB;;AAER;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,0BAA0B;IAC1B,wBAAwB;IACxB,6BAA6B;IAC7B,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,wBAAwB;AAC5B;;IAEI;QACI,cAAc;QACd,UAAU;IACd;;AAEJ;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;IAC5B,+CAA+C;AACnD;;AAEA;IACI;QACI,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,UAAU;IACd;;IAEA;QACI,qBAAqB;QACrB,YAAY;IAChB;AACJ","sourcesContent":["@import '../../css/App.css';\r\n\r\n.skitterbook-live-print-button-container {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-content: center;\r\n    flex-wrap: wrap;\r\n    gap: 1rem;\r\n}\r\n\r\n.skitterbook-live-print-button {\r\n    position: relative;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.skitterbook-live-print-button {\r\n    color: inherit;\r\n}\r\n\r\n    .skitterbook-live-print-button > .glyph-button-content {\r\n        color: inherit;\r\n    }\r\n\r\n        .skitterbook-live-print-button > .glyph-button-content > svg {\r\n            stroke: inherit;\r\n            fill: inherit;\r\n        }\r\n\r\n.skitterbook-live-print-button--ready {\r\n    color: var(--color-success);\r\n    stroke: var(--color-success);\r\n    fill: var(--color-success);\r\n}\r\n\r\n.skitterbook-live-print-button--loading {\r\n    color: var(--color-disabled-fore);\r\n    stroke: var(--color-disabled-fore);\r\n    fill: var(--color-disabled-fore);\r\n}\r\n\r\nsvg.error-information {\r\n    position: absolute;\r\n    left: 16px;\r\n    top: 16px;\r\n    stroke: var(--color-error);\r\n    fill: var(--color-error);\r\n    transition: opacity 0.5s ease;\r\n    opacity: 0;\r\n    display: none;\r\n}\r\n\r\n.skitterbook-live-print-button--error {\r\n    color: var(--color-error);\r\n    stroke: var(--color-error);\r\n    fill: var(--color-error);\r\n}\r\n\r\n    .skitterbook-live-print-button--error ~ svg.error-information {\r\n        display: block;\r\n        opacity: 1;\r\n    }\r\n\r\n.skitterbook-live-print-button--building > .glyph-button-content {\r\n    color: var(--color-secondary);\r\n    stroke: var(--color-secondary);\r\n    fill: var(--color-secondary);\r\n    animation: sbpb-pulse 1.4s ease-in-out infinite;\r\n}\r\n\r\n@keyframes sbpb-pulse {\r\n    0% {\r\n        transform: scale(0.9);\r\n        opacity: 0.6;\r\n    }\r\n\r\n    50% {\r\n        transform: scale(1.1);\r\n        opacity: 1;\r\n    }\r\n\r\n    100% {\r\n        transform: scale(0.9);\r\n        opacity: 0.6;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
